import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { I18n } from 'react-redux-i18n-lite';
import { DRAWER_CONTENTS } from '../../../const';
import * as accountActions from '../../../actions/accountActions';
import * as componentActions from '../../../actions/componentActions';
import * as sectionActions from '../../../actions/sectionActions';
import * as drawerActions from '../../../actions/drawerActions';
import * as classroomActions from '../../../actions/classroom/classroomActions';
import { isElectronApp } from '../../../services/crossPlatform/crossPlatformService';
import { openStatusPage } from '../../../electron/windowManager';
import { SMART_STATUS_URL } from '../../../const';
import { NETEX_INFRA } from '../../../config_module';
import Media from 'react-media';
import { BottomSheet, BottomSheetAction, BottomSheetDivider } from '@netexknowledge/smart-components';
import { MOBILE_MEDIA_QUERY } from '../../../utils/mobileUtils';

export class UserProfileDropDown extends React.Component {
  constructor(props) {
    super(props);
    this.handlerClick = this.handlerClick.bind(this);
    this.handlerClose = this.handlerClose.bind(this);
    this.logoutHandler = this.logoutHandler.bind(this);
    this.getUserPicture = this.getUserPicture.bind(this);
    this.state = { open: false };
  }

  static propTypes = {
    pathname: PropTypes.string,
    user: PropTypes.object,
    isAppOnline: PropTypes.any,
    sectionActions: PropTypes.object,
    accountActions: PropTypes.object,
    classroomActions: PropTypes.object,
    configuration: PropTypes.object,
    options: PropTypes.object,
    drawerActions: PropTypes.object
  };

  handlerClick() {
    const { open } = this.state;

    this.setState({
      open: !open
    });
  }

  handlerClose() {
    this.setState({
      open: false
    });
  }

  openProfile(isAppOnline, drawerActions) {
    if (isAppOnline) {
      drawerActions.openDrawerAndSetContent(DRAWER_CONTENTS.CREATE_PROFILE_PANEL);
    }
  }

  openCookiesMenu(isAppOnline, drawerActions) {
    if (isAppOnline) {
      drawerActions.openDrawerAndSetContent(DRAWER_CONTENTS.CREATE_COOKIES_PANEL);
    }
  }

  logoutHandler() {
    //googleOnClick();
    this.props.accountActions.logout();
  }

  getUserPicture() {
    const { user } = this.props;
    if (user.picture) {
      return <img src={user.picture} alt="presentation" />;
    }
    return '';
  }

  renderEmail() {
    const { user } = this.props;

    return (
      <div id="user-profile-drop-down-email" className="text">
        <span>{user.email}</span>
      </div>
    );
  }

  renderUserInfo() {
    const { user, options } = this.props;
    return (
      <div className="profile">
        <div className="picture">{this.getUserPicture()}</div>

        <div className="data">
          <div className="header">
            <span>
              {user.name} {user.surname}
            </span>
          </div>
          {this.renderEmail()}
          {options && this.renderNetexCloudUserOptions(options)}
        </div>
      </div>
    );
  }

  renderUserConfigItem() {
    const { configuration, isAppOnline, drawerActions } = this.props;
    if (!configuration.hideUserConfig) {
      return (
        <div
          className={isAppOnline ? 'link' : 'data'}
          onClick={isAppOnline ? () => this.openProfile(isAppOnline, drawerActions) : ''}
        >
          <div className={isAppOnline ? 'item' : 'disabledOffline'}>
            <span className="text">{I18n.t('userProfile.settings')}</span>
          </div>
        </div>
      );
    }
  }

  renderCookiesConfigItem() {
    const { isAppOnline, drawerActions } = this.props;
    return (
      <div
        className={isAppOnline ? 'link' : 'data'}
        onClick={isAppOnline ? () => this.openCookiesMenu(isAppOnline, drawerActions) : ''}
      >
        <div className={isAppOnline ? 'item' : 'disabledOffline'}>
          <span className="text">{I18n.t('panels.cookies.configCookies')}</span>
        </div>
      </div>
    );
  }

  renderStatusLinkItem() {
    const { isAppOnline, drawerActions } = this.props;
    if (!isElectronApp()) {
      return (
        <a href={SMART_STATUS_URL} target="_blank" rel="noopener noreferrer">
          <div className={isAppOnline ? 'link' : 'data'}>
            <div className={isAppOnline ? 'item' : 'disabledOffline'}>
              <span className="text">{I18n.t('userProfile.statusPage')}</span>
            </div>
          </div>
        </a>
      );
    }

    const handleStatusPageClick = () => {
      if (isAppOnline) {
        openStatusPage(SMART_STATUS_URL);
      }
    };

    return (
      <div onClick={handleStatusPageClick} className={isAppOnline ? 'link' : 'data'}>
        <div className={isAppOnline ? 'item' : 'disabledOffline'}>
          <span className="text">{I18n.t('userProfile.statusPage')}</span>
        </div>
      </div>
    );
  }

  renderItems() {
    const { options, showStatusLink } = this.props;
    if (options) {
      return (
        <div className="items-container-netexcloud">
          {options.whatsNew && (
            <div>
              <a href={options.whatsNew.url} target={options.whatsNew.target}>
                {options.whatsNew.label}
              </a>
            </div>
          )}
          {options.userManual && (
            <div>
              <a href={options.userManual.url} target={options.userManual.target}>
                {options.userManual.label}
              </a>
            </div>
          )}
          {options.helpCenter && (
            <div>
              <a href={options.helpCenter.url} target={options.helpCenter.target}>
                {options.helpCenter.label}
              </a>
            </div>
          )}
        </div>
      );
    }
    return (
      <div className="items-container">
        {this.renderUserConfigItem()}
        {this.renderCookiesConfigItem()}
        {showStatusLink && NETEX_INFRA && this.renderStatusLinkItem()}
        <div onClick={() => this.logoutHandler()} className="link">
          <div className="item warning-option">
            <span className="text">{I18n.t('login.logout')}</span>
          </div>
        </div>
      </div>
    );
  }

  renderContent() {
    return (
      <div className="user-profile-drop-down">
        {this.renderUserInfo()}
        {this.renderItems()}
        {this.renderLogout()}
      </div>
    );
  }

  // Mobile (Vista Mobile): same options in a bottom sheet. Internal sections show ›, external links an
  // "opens elsewhere" icon, and logout is the destructive action at the end.
  renderExternalLabel(text) {
    return (
      <span className="sheet-action-external">
        {text}
        <i className="custom-icons-no-interactive" aria-hidden="true" />
      </span>
    );
  }

  runAndClose(action) {
    this.handlerClose();
    action();
  }

  openStatus() {
    if (isElectronApp()) {
      openStatusPage(SMART_STATUS_URL);
    } else {
      window.open(SMART_STATUS_URL, '_blank', 'noopener');
    }
  }

  renderExternalAction(option) {
    return (
      option && (
        <BottomSheetAction
          key={option.url}
          label={this.renderExternalLabel(option.label)}
          onClick={() => this.runAndClose(() => window.open(option.url, option.target || '_blank'))}
        />
      )
    );
  }

  renderMobileActions() {
    const { options, showStatusLink, configuration, isAppOnline, drawerActions } = this.props;

    if (options) {
      return (
        <>
          {[
            options.account,
            options.notifications,
            options.news,
            options.whatsNew,
            options.userManual,
            options.helpCenter
          ].map(option => this.renderExternalAction(option))}
          {options.logout && (
            <>
              <BottomSheetDivider />
              <BottomSheetAction
                danger
                label={options.logout.label}
                onClick={() =>
                  this.runAndClose(() => window.open(options.logout.url, options.logout.target || '_self'))
                }
              />
            </>
          )}
        </>
      );
    }

    return (
      <>
        {!configuration.hideUserConfig && (
          <BottomSheetAction
            label={I18n.t('userProfile.settings')}
            navigates
            disabled={!isAppOnline}
            onClick={() => this.runAndClose(() => this.openProfile(isAppOnline, drawerActions))}
          />
        )}
        <BottomSheetAction
          label={I18n.t('panels.cookies.configCookies')}
          navigates
          disabled={!isAppOnline}
          onClick={() => this.runAndClose(() => this.openCookiesMenu(isAppOnline, drawerActions))}
        />
        {showStatusLink && NETEX_INFRA && (
          <BottomSheetAction
            label={this.renderExternalLabel(I18n.t('userProfile.statusPage'))}
            disabled={!isAppOnline}
            onClick={() => this.runAndClose(() => this.openStatus())}
          />
        )}
        <BottomSheetDivider />
        <BottomSheetAction danger label={I18n.t('login.logout')} onClick={() => this.runAndClose(this.logoutHandler)} />
      </>
    );
  }

  renderMobileSheet() {
    const { user } = this.props;
    return (
      <BottomSheet
        open={this.state.open}
        onClose={this.handlerClose}
        closeLabel={I18n.t('common.close')}
        title={`${user.name} ${user.surname}`}
        subtitle={user.email}
        media={user.picture ? <img className="sheet-media-avatar" src={user.picture} alt="" /> : undefined}
      >
        {this.renderMobileActions()}
      </BottomSheet>
    );
  }

  renderMobile() {
    const { user } = this.props;
    return (
      <div className="custom-drop-down-options float-right">
        <div
          className="options-drop-down-pane"
          role="button"
          tabIndex="0"
          aria-haspopup="dialog"
          aria-expanded={this.state.open}
          aria-label={`${user.name} ${user.surname}`}
          onClick={event => {
            event.currentTarget.blur();
            this.setState({ open: true });
          }}
        >
          <h5 className="user-avatar">{this.getUserPicture()}</h5>
        </div>
        {this.renderMobileSheet()}
      </div>
    );
  }

  render() {
    return (
      <Media query={MOBILE_MEDIA_QUERY}>{isMobile => (isMobile ? this.renderMobile() : this.renderDesktop())}</Media>
    );
  }

  renderDesktop() {
    const { open } = this.state;
    let showLarge = open ? 'show-large' : '';
    let show = open ? 'show' : '';

    return (
      <div className="custom-drop-down-options float-right" onBlur={this.handlerClose} tabIndex="-1">
        <div className="options-drop-down-pane" onClick={this.handlerClick}>
          <h5 className="user-avatar">{this.getUserPicture()}</h5>
        </div>
        <div className={`custom-drop-down-pane down ${showLarge}`}>
          <div className={`custom-drop-down-pane-content ${show}`}>{this.renderContent()}</div>
        </div>
      </div>
    );
  }

  renderNetexCloudUserOptions(options) {
    return (
      <div>
        <div>
          <a href={options.account.url} target={options.account.target}>
            {options.account.label}
          </a>
        </div>
        <div>
          <a href={options.notifications.url} target={options.notifications.target}>
            {options.notifications.label}
          </a>
        </div>
        <div>
          <a href={options.news.url} target={options.news.target}>
            {options.news.label}
          </a>
        </div>
      </div>
    );
  }

  renderLogout() {
    const { options } = this.props;
    if (options) {
      return (
        <div>
          <hr></hr>
          <div className="items-container-netexcloud">
            <a href={options.logout.url} target={options.logout.target}>
              {options.logout.label}
            </a>
          </div>
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    pathname: state.router.location.pathname,
    user: state.account.user,
    isAppOnline: state.connection.status.online,
    inProfile: state.router.inProfile,
    configuration: state.account.configuration
  };
}

function mapDispatchToProps(dispatch) {
  return {
    accountActions: bindActionCreators(accountActions, dispatch),
    componentActions: bindActionCreators(componentActions, dispatch),
    sectionActions: bindActionCreators(sectionActions, dispatch),
    classroomActions: bindActionCreators(classroomActions, dispatch),
    drawerActions: bindActionCreators(drawerActions, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UserProfileDropDown);
